import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { TeacherPageBody, TeacherPageContent } from '../teacher/Styles';
import { TeacherHeader } from '../teacher/ui/header/TeacherHeader';
import { AdminSideBar } from './ui/sidebar/AdminSideBar';

const AdminContainer = styled(TeacherPageContent)`
  padding: 30px;
  background: #f3f5fb;
`;

// Обёртка раздела администратора в едином стиле с Teacher
export const AdminPage = () => {
  return (
    <TeacherPageBody>
      <TeacherHeader />
      <AdminSideBar />
      <AdminContainer>
        <Outlet />
      </AdminContainer>
    </TeacherPageBody>
  );
};


